import React from 'react';

interface LoadingSpinnerProps {
  message?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ message = 'Loading...' }) => {
  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center bg-[#1a1a1a]"
      role="status"
      aria-live="polite"
      aria-label={message}
    >
      <div className="flex flex-col items-center gap-4">
        {/* Spinner Animation */}
        <div 
          className="relative h-16 w-16"
          aria-hidden="true"
        >
          <div className="absolute inset-0 rounded-full border-4 border-gray-700 opacity-25"></div>
          <div className="absolute inset-0 animate-spin rounded-full border-4 border-[#6366f1] border-t-transparent"></div>
        </div>
        
        {/* Loading Message */}
        {message && (
          <p className="text-white text-lg font-medium" aria-live="polite">
            {message}
          </p>
        )}
      </div>
    </div>
  );
};

export default LoadingSpinner;
